import axios from "axios";
import config from "../../config";

const baseUrl = `${config.baseUrl}/api/participantes`;

// En participantesService.js - Agregar logging
export async function getParticipantes(params = {}, userInfo = {}, signal) {
  const {
    page = 1,
    pageSize = 20,
    search = "",
    estado,
    municipioId,
    departamentoId,
    genero,
    promotoresId,
    exportAll = false
  } = params;

  const { usuarioId, ip, usuarioMunicipioId, esAdmin } = userInfo;

  const queryParams = {
    page,
    pageSize,
    search: search || undefined,
    estado,
    municipioId,
    departamentoId,
    genero,
    promotoresId,
    exportAll
  };

  Object.keys(queryParams).forEach(key => {
    if (
      queryParams[key] === undefined ||
      queryParams[key] === null ||
      queryParams[key] === ''
    ) {
      delete queryParams[key];
    }
  });

  const response = await axios.get(baseUrl, {
    params: queryParams,
    headers: {
      "x-usuario-id": usuarioId,
      "x-user-ip": ip,
      "x-usuario-municipio-id": usuarioMunicipioId,
      "x-usuario-es-admin": esAdmin?.toString() || "false"
    },
    signal
  });

  return response.data;
}

export async function getParticipante(id, userInfo = {}) {
  const { usuarioId, ip } = userInfo;

  const response = await axios.get(`${baseUrl}/${id}`, {
    headers: {
      "x-usuario-id": usuarioId,
      "x-user-ip": ip
    }
  });

  return response.data;
}

export async function createParticipante(data, userInfo = {}) {
  const { usuarioId, ip } = userInfo;

  return axios.post(baseUrl, data, {
    headers: {
      "x-usuario-id": usuarioId,
      "x-user-ip": ip
    }
  });
}

export async function updateParticipante(id, data, userInfo = {}) {
  const { usuarioId, ip } = userInfo;

  return axios.put(`${baseUrl}/${id}`, data, {
    headers: {
      "x-usuario-id": usuarioId,
      "x-user-ip": ip
    }
  });
}

export async function deleteParticipante(id, userInfo = {}) {
  const { usuarioId, ip } = userInfo;

  return axios.delete(`${baseUrl}/${id}`, {
    headers: {
      "x-usuario-id": usuarioId,
      "x-user-ip": ip
    }
  });
}

// 🔥 NUEVO: Métricas para gráficas
export async function getMetricasParticipantes(userInfo = {}) {
  const { usuarioId, ip, usuarioMunicipioId, esAdmin } = userInfo;

  const response = await axios.get(`${baseUrl}/metricas`, {
    headers: {
      "x-usuario-id": usuarioId,
      "x-user-ip": ip,
      "x-usuario-municipio-id": usuarioMunicipioId,
      "x-usuario-es-admin": esAdmin?.toString() || "false"
    }
  });
  return response.data;
}